import React from "react";
import { Card, Grid, Typography } from '@curves/ui-base';

import ReadTextField from "@Local/Components/ReadTextField";
const PaymentSectionByRead = props => {
    const { payment } = props;
	return (
		<Card>
			<Card.CardHeader
				title={
					<Typography variant="body-1" className="font-weight-900">
						付款資訊
					</Typography>
				}
				className="bg-black"
			/>
			<Card.CardContent className="p-4">
				<Grid spacing={3} container>
					<Grid xs={4} item>
						<ReadTextField label="信用卡號">{payment?.creditCardNo}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="有效期限">{payment?.cardExpiryDate}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="持卡人姓名">{payment?.cardName}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="卡片關係人">{payment?.cardRelation}</ReadTextField>
					</Grid>
					<Grid xs={4} item>
						<ReadTextField label="卡別">{payment?.creditCardTypeText}</ReadTextField>
					</Grid>
				</Grid>
			</Card.CardContent>
		</Card>
	);
};
export default PaymentSectionByRead;
